/* Optimal Pet — product page behaviour */
(function () {
  function initPd(root) {
    if (root.dataset.opReady) return;
    root.dataset.opReady = '1';
    var data = JSON.parse(root.querySelector('[data-op-product-json]').textContent);
    var slides = root.querySelector('[data-op-slides]');
    var thumbs = root.querySelectorAll('[data-op-thumb]');
    var idxEl = root.querySelector('[data-op-idx]');
    var n = slides ? slides.children.length : 0, cur = 0;

    function setActive(i) {
      cur = i;
      if (idxEl) idxEl.textContent = i + 1;
      thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === i); });
      var t = thumbs[i]; if (t && t.parentNode.scrollTo) t.parentNode.scrollTo({ left: t.offsetLeft - 40, behavior: 'smooth' });
    }
    function goTo(i, instant) {
      if (!slides || !n) return;
      i = (i + n) % n;
      slides.scrollTo({ left: slides.clientWidth * i, behavior: instant ? 'auto' : 'smooth' });
      setActive(i);
    }
    if (slides) {
      var tm;
      slides.addEventListener('scroll', function () {
        clearTimeout(tm);
        tm = setTimeout(function () { setActive(Math.round(slides.scrollLeft / slides.clientWidth)); }, 80);
      }, { passive: true });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { goTo(+t.dataset.opThumb); }); });
    var prev = root.querySelector('[data-op-prev]'), next = root.querySelector('[data-op-next]');
    if (prev) prev.addEventListener('click', function () { goTo(cur - 1); });
    if (next) next.addEventListener('click', function () { goTo(cur + 1); });
    function goToMedia(id, instant) {
      if (!slides || !id) return;
      var el = slides.querySelector('[data-media-id="' + id + '"]');
      if (el) goTo(Array.prototype.indexOf.call(slides.children, el), instant);
    }

    var vidInput = root.querySelector('[data-op-vid]');
    var price = root.querySelector('[data-op-price]'), compare = root.querySelector('[data-op-compare]'), save = root.querySelector('[data-op-save]');
    var atc = root.querySelector('[data-op-atc]'), atcLabel = root.querySelector('[data-op-atc-label]');
    var fieldsets = root.querySelectorAll('[data-op-opt]');
    function selected() {
      return Array.prototype.map.call(fieldsets, function (fs) { var c = fs.querySelector('input:checked'); return c ? c.value : null; });
    }
    function find(opts) {
      for (var i = 0; i < data.variants.length; i++) {
        var v = data.variants[i], ok = true;
        for (var j = 0; j < opts.length; j++) if (v.options[j] !== opts[j]) { ok = false; break; }
        if (ok) return v;
      }
      return null;
    }
    function update() {
      var opts = selected(), v = find(opts);
      fieldsets.forEach(function (fs, i) { var l = fs.querySelector('[data-op-opt-label]'); if (l) l.textContent = (opts[i] || '').split(' — ')[0]; });
      if (!v) { atc.disabled = true; atcLabel.textContent = 'Unavailable'; return; }
      vidInput.value = v.id;
      price.textContent = OP.money(v.price);
      var onSale = v.compare_at_price && v.compare_at_price > v.price;
      compare.hidden = !onSale; save.hidden = !onSale;
      if (onSale) { compare.textContent = OP.money(v.compare_at_price); save.textContent = 'Save ' + OP.money(v.compare_at_price - v.price); }
      atc.disabled = !v.available;
      atcLabel.textContent = v.available ? (root.dataset.atcLabel || 'Add to cart') : 'Sold out';
      try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString()); } catch (e) {}
      if (v.featured_media) goToMedia(v.featured_media.id);
    }
    fieldsets.forEach(function (fs) { fs.addEventListener('change', update); });

    root.querySelectorAll('[data-op-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        var input = root.querySelector('input[name="quantity"]');
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.dataset.opQty, 10));
      });
    });

    if (root.dataset.initialMedia) window.addEventListener('load', function () { goToMedia(root.dataset.initialMedia, true); });

    function rating() {
      var rv = document.querySelector('[data-op-reviews]'), btn = root.querySelector('[data-op-rating]');
      if (!rv || !btn || !(+rv.dataset.count > 0)) return;
      var avg = parseFloat(rv.dataset.avg), count = +rv.dataset.count;
      btn.querySelector('[data-op-rating-stars]').style.setProperty('--r', (avg * 20) + '%');
      btn.querySelector('[data-op-rating-text]').textContent = avg.toFixed(1) + ' · ' + count + (count === 1 ? ' review' : ' reviews');
      btn.hidden = false;
      btn.onclick = function () { rv.scrollIntoView({ behavior: 'smooth', block: 'start' }); };
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', rating); else rating();
  }
  function boot() { document.querySelectorAll('[data-op-pd]').forEach(initPd); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
/* Mobile sticky add-to-cart bar: appears once the main buy button has scrolled out of view. */
(function () {
  function initBar(root) {
    if (root.querySelector('.op-pd__bar')) return;
    var buy = root.querySelector('.op-pd__buy'), atc = root.querySelector('[data-op-atc]');
    var price = root.querySelector('[data-op-price]'), title = root.querySelector('.op-pd__title');
    if (!buy || !atc || !price || !('IntersectionObserver' in window)) return;
    var bar = document.createElement('div');
    bar.className = 'op-pd__bar'; bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML = '<div class="op-pd__bar-info"><strong></strong><span></span></div><button type="button" class="op__btn op-pd__bar-btn" tabindex="-1"></button>';
    root.appendChild(bar);
    var bTitle = bar.querySelector('strong'), bMeta = bar.querySelector('span'), bBtn = bar.querySelector('button');
    function sync() {
      bTitle.textContent = title ? title.textContent.trim() : '';
      var labels = [].map.call(root.querySelectorAll('[data-op-opt-label]'), function (l) { return l.textContent.trim(); });
      bMeta.textContent = price.textContent.trim() + (labels.length ? ' · ' + labels.join(' / ') : '');
      bBtn.textContent = atc.textContent.trim(); bBtn.disabled = atc.disabled;
    }
    sync();
    new MutationObserver(sync).observe(root.querySelector('.op-pd__info') || root, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled'] });
    bBtn.addEventListener('click', function () { if (!atc.disabled) atc.click(); });
    new IntersectionObserver(function (es) {
      var e = es[0], below = !e.isIntersecting && e.boundingClientRect.top < 0;
      bar.classList.toggle('is-on', below); bar.setAttribute('aria-hidden', below ? 'false' : 'true');
      bBtn.tabIndex = below ? 0 : -1;
    }).observe(buy);
  }
  function boot() { document.querySelectorAll('[data-op-pd]').forEach(initBar); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();